import axios from "axios";

/**
 * MariaM - API Client
 * - Em produção: prioriza REACT_APP_API_URL; se não existir, usa "/api" (ideal com proxy Nginx)
 * - Em dev: fallback para "http://localhost:3006/api"
 *
 * Exemplos de produção:
 * - REACT_APP_API_URL="https://api.mariam.com.br/api"
 * - ou (com proxy no mesmo domínio) REACT_APP_API_URL="/api"
 */
const isProd = process.env.NODE_ENV === "production";

const baseURL =
  process.env.REACT_APP_API_URL ||
  (isProd ? "/api" : "http://localhost:3006/api");

const api = axios.create({
  baseURL,
  timeout: 20000, // evita ficar travado indefinidamente
});

// ✅ mesma regra do ProtectedRoute
const getValidToken = () => {
  const token = localStorage.getItem("token");
  const isValid =
    token && token !== "undefined" && token !== "null" && token.trim() !== "";

  if (!isValid) {
    localStorage.removeItem("token");
    return null;
  }
  return token;
};

api.interceptors.request.use(
  (config) => {
    const token = getValidToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (config.headers?.Authorization) {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Se o backend disser que o token não vale mais, limpamos o token.
// (Não redireciona aqui para não quebrar a lógica do Home/ProtectedRoute.)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

export default api;